type RuntimeEnv = Record<string, string | undefined>

const runtime: RuntimeEnv =
  (typeof window !== 'undefined' &&
    (window as unknown as { _env_?: RuntimeEnv })._env_) ||
  {}

// Runtime config: window._env_ is generated at container start from the host
// .env (Docker/30-generate-env-js.sh). The process.env.* fallbacks are inlined
// by react-scripts at build time and only apply to local `yarn start` dev.
export const ENV = {
  GRAPH_BFF:
    runtime.REACT_APP_GRAPH_BFF ?? process.env.REACT_APP_GRAPH_BFF ?? '',
  GRAPH_BFF_WS:
    runtime.REACT_APP_GRAPH_BFF_WS ?? process.env.REACT_APP_GRAPH_BFF_WS ?? '',
  BASE_URL: runtime.REACT_APP_BASE_URL ?? process.env.REACT_APP_BASE_URL ?? '',
  API_BASE_URL:
    runtime.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL ?? '',
  WBS_BACK_BASE_URL:
    runtime.REACT_APP_WBS_BACK_BASE_URL ??
    process.env.REACT_APP_WBS_BACK_BASE_URL ??
    '',
  WBS_SITE_KEY:
    runtime.REACT_APP_WBS_SITE_KEY ?? process.env.REACT_APP_WBS_SITE_KEY ?? '',
  SENTRY_DSN:
    runtime.REACT_APP_SENTRY_DSN ?? process.env.REACT_APP_SENTRY_DSN ?? ''
}
